export class SidebarMenuHandler {
  constructor(el) {
    this.sidebarMenu = el;
    this.sideBarMenuFirst = this.sidebarMenu?.querySelector('.SidebarMenu__Nav[first-level]');
    this.headersideBarButtonIcon = document.querySelector('.Header__Icon');

    if (this.sidebarMenu) {
      this.setupEvents();
    }
  }

  setupEvents() {
    this.headersideBarButtonIcon?.addEventListener('click', () => {
      document.querySelectorAll('.adjusted-height__from-current-section').forEach((el) => {
        el.style.height = '';
      });
    });

    this.sidebarMenu.querySelectorAll('.Collapsible a').forEach((item) => {
      item.addEventListener('click', (e) => this.handleHistory(e, item));
    });

    this.sidebarMenu.querySelectorAll("[data-action='open-level-2']").forEach((item) => {
      item.addEventListener('click', (e) => this.openLevel(e, item, 2));
    });

    this.sidebarMenu.querySelectorAll("[data-action='open-level-3']").forEach((item) => {
      item.addEventListener('click', (e) => this.openLevel(e, item, 3));
    });

    this.sidebarMenu.querySelectorAll('[data-action="back"]').forEach((item) => {
      item.addEventListener('click', (e) => this.goBack(e, item));
    });
  }

  openSidebar() {
    this.headersideBarButtonIcon.click();
  }

  handleHistory(e, item) {
    e.preventDefault();
    const level = item.closest('[data-level]');
    const levelNumber = parseInt(level.getAttribute('data-level'), 10);

    history.pushState({ sidebarLevel: levelNumber, item: item.getAttribute('local-id') }, '', item.getAttribute('href'));


    setTimeout(() => {
      window.location.href = `${item.getAttribute('href')}`;
    }, 200);
  }

  openLevel(e, item, level, redirected = false) {
    e.preventDefault();
    let parent;
    let levelEl;
    if (!redirected) {
      parent = item.parentElement;
      levelEl = parent.querySelector(`[data-level='${level}']`);
      levelEl.setAttribute('aria-hidden', levelEl.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
    }
    else {
      if (level === 3) {
        parent = item.closest('.SidebarMenu__Nav').closest('.Collapsible');
        levelEl = parent.querySelector(`[data-level='${level}']`);
        levelEl.setAttribute('aria-hidden', levelEl.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');

        const newLevelEl = levelEl.closest('.Collapsible').closest('section.SidebarMenu.Drawer[aria-hidden]');
        newLevelEl.setAttribute('aria-hidden', newLevelEl.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }

      else if (level == 2) {
        parent = item.closest('.SidebarMenu__Nav').closest('.Collapsible');
        levelEl = parent.querySelector(`[data-level='${level}']`);
        levelEl.setAttribute('aria-hidden', levelEl.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }
    }

    if (!levelEl || levelEl === null) {
      levelEl = parent;
    }

    setTimeout(() => {
      this.adjustHeightOfSidebarSections(item, levelEl);
    }, 0);


    if (level === 3) {
      const level2 = parent.closest("[data-level='2']");
      const nav = levelEl.querySelector('.SidebarMenu__Nav--primary');
      const drawerMain = level2.querySelector('.Drawer__Main');

      if (nav.offsetHeight < 700) {
        drawerMain.style.overflowY = 'hidden';
        drawerMain.scrollTo(0, 0);
      } else {
        drawerMain.style.overflowY = 'auto';
      }
    }
  }

  goBack(e, item) {
    e.preventDefault();
    const parent = item.parentElement;
    const level = parent.closest('[data-level]');
    const previousLevel = level.previousElementSibling;

    level.setAttribute('aria-hidden', 'true');
    previousLevel.closest('.Drawer__Main').style.overflowY = 'auto';
    previousLevel.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
      const previousLevelButton = previousLevel
        ?.closest('.Collapsible')
        ?.closest('.Drawer__Main')
        ?.closest('.Collapsible')
        ?.querySelector('.Collapsible__Button');
      this.adjustHeightOfSidebarSections(previousLevelButton);
    }, 0);
  }

  adjustHeightOfSidebarSections(wrapper, sectionOverride = null) {
    document.querySelectorAll('.adjusted-height__from-current-section').forEach((el) => {
      el.style.height = '';
    });

    const currSection = sectionOverride || wrapper?.closest('.Collapsible')?.querySelector('section.SidebarMenu');
    const currSideBarMenu = currSection?.querySelector('.Drawer__Container .SidebarMenu__Nav');
    let currSideBarMenuHeight = currSideBarMenu?.offsetHeight || 0;

    const visibleClientHeight = window.innerHeight || document.documentElement.clientHeight;
    const isMenuBiggerThanScreen = currSideBarMenuHeight + 120 > visibleClientHeight;

    if (isMenuBiggerThanScreen) {
      document.querySelectorAll('section.SidebarMenu.Drawer').forEach((el) => {
        el.style.height = `calc(${currSideBarMenuHeight}px + 120px)`;
        el.classList.add('adjusted-height__from-current-section');
      });

      this.sideBarMenuFirst.style.height = `calc(${currSideBarMenuHeight}px)`;
      this.sideBarMenuFirst.classList.add('adjusted-height__from-current-section');
    }
  }
}

const sideBarMenu = document.querySelector('#sidebar-menu');
let sideBarMenuHandlerInstance = null;
if (sideBarMenu) {
  sideBarMenuHandlerInstance = new SidebarMenuHandler(sideBarMenu);
}

if (window.innerWidth <= 768) {
  let handled = false;
  const activeNavigationItemId = history.state?.item;
  const sidebarLevel = history.state?.sidebarLevel;

  window.addEventListener('popstate', function (e) {
    if (sidebarLevel && sidebarLevel && !handled) {
      handled = true;

      openSidebarAtLevel(sidebarLevel, activeNavigationItemId, e);
      history.pushState({ sidebarLevel: sidebarLevel ? sidebarLevel : 3, item: activeNavigationItemId ? activeNavigationItemId : '' }, '', window.location.href);

      setTimeout(() => handled = false, 500);
    }
  });
}

function openSidebarAtLevel(level, activeNavigationItemId, event) {
  event.preventDefault();
  const itemAttribute = `[local-id="${activeNavigationItemId}"]`;
  const item = document.querySelector(itemAttribute);

  sideBarMenuHandlerInstance.openSidebar();

  if (level === 2 || level === 3) {
    sideBarMenuHandlerInstance.openLevel(event, item, level, true);
  }
}